type Props = {
  value: number;
  min: number;
  max: number;
  step: number;
  disabled?: boolean;
  ariaLabel: string;
  /** Läsbar variant av värdet för skärmläsare ("Så snart som möjligt" / "1 h 15 min"). */
  ariaValueText: string;
  onChange: (value: number) => void;
};

export function TimeSlider({
  value,
  min,
  max,
  step,
  disabled = false,
  ariaLabel,
  ariaValueText,
  onChange,
}: Props) {
  const fill = max > min ? ((value - min) / (max - min)) * 100 : 0;

  return (
    <div className="time-slider">
      <div className="time-slider-track" style={{ ['--fill' as string]: `${fill}%` }} />
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        disabled={disabled}
        aria-label={ariaLabel}
        aria-valuetext={ariaValueText}
        onChange={(e) => onChange(Number(e.target.value))}
      />
    </div>
  );
}
